import script from "./DatasetControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetControls.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetControls.vue?vue&type=style&index=0&id=67310206&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67310206"]])

export default __exports__